<template>
	<div class="nm-holder" tabindex="1">
		<div class="nm-dim" v-if="filteredItems.length > 0">
			<div class="nm-dim-inner" v-for="m of filteredItems" :key="m.key">
				<nk-modal :page="m.item" @showHelp="showHelp"></nk-modal>
			</div>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash'
	export default {
		props: ['items'],
		emits: ['showHelp'],
		data() {
			return {
				uniqueKey: 1
			}
		},
		computed: {
			filteredItems() {
				let list = [].concat(this.items)
				return list.map((item, index) => {
					let key = _.get(item, 'component.modal.stateUID')
					key = key || this.getUniqueKey()
					return {
						key,
						item
					}
				})
			}
		},
		methods: {
			showHelp() {
				this.$emit('showHelp')
			},
			getUniqueKey() {
				return this.uniqueKey++
			}
		}
	}
</script>
<style></style>
